// custom-instance.ts
import Axios, { AxiosRequestConfig } from 'axios';

import setAuthorizationHeaderInterceptor from '@/axios/interceptors/AuthorizationHeaderInterceptor';
import setRefreshInterceptor from '@/axios/interceptors/refreshInterceptor';

export type JourneyJwt = Record<string, string>;

declare module 'axios' {
  interface AxiosRequestConfig {
    // Add the parameter used by axios-auth-refresh to skip its own queuing logic when running the refresh query
    skipAuthRefresh?: boolean;
  }
}

export const AXIOS_INSTANCE = Axios.create({
  baseURL: process.env.VITE_API_BASE
});

// add a second `options` argument here if you want to pass extra options to each generated query
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  const source = Axios.CancelToken.source();
  const promise = AXIOS_INSTANCE({
    ...config,
    ...options,
    cancelToken: source.token
  }).then(({ data }) => data);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  promise.cancel = () => {
    source.cancel('Query was cancelled');
  };

  return promise;
};

// set interceptors
setAuthorizationHeaderInterceptor();
setRefreshInterceptor();

export default customInstance;
